import "regenerator-runtime/runtime"; // needed for promises and async/await
import { Core } from "../../../VanillaCore";
import {postData} from "../../../webpack-js/api";

export default class MultiStepProgressComponent extends Core.Component {
    constructor(sandbox: Core.Sandbox) {
        super(sandbox);
    }

    init() {
        this.multiStepProgress = document.querySelector('.multi-step-progress');
        if (this.multiStepProgress) {
            const { steps: stepsProp, currentStep: currentStepProp } = this.multiStepProgress.dataset;
            const steps = parseInt(stepsProp);
            const currentStep = parseInt(currentStepProp);
            for (let i = 1; i <= steps; i++) {
                const newListItem = this.createNewListItem(i, currentStep);
                this.multiStepProgress.appendChild(newListItem);
            }
        }
    }

    createNewListItem(i, currentStep) {
        const newListItem = document.createElement('li');
        if (i < currentStep) {
            newListItem.classList.add('done');
        } else if (i === currentStep) {
            newListItem.classList.add('active');
        }
        newListItem.appendChild(this.createStepSpan(i));
        return newListItem;
    }

    createStepSpan(value) {
        const newStepSpan = document.createElement('span');
        newStepSpan.classList.add('step');
        newStepSpan.innerText = value;
        return newStepSpan;
    }

    // eslint-disable-next-line class-methods-use-this
    destroy() {}
}